import {composeReducers} from 'common/util/composeReducers';
import lodash from 'lodash';
import {
    ADD_OR_MODIFY_STUDY_TESTAMENT,
    GET_ALL_STUDY_TEMPLATES_FOR_INSTITUTION,
    ADD_OR_MODIFY_STUDY_TEMPLATE,
} from 'complionAdmin/actions/delegationOfAuthorityConfiguration';

export function addOrModifyStudyTestament(state, action){
    if (!action || action.type !== ADD_OR_MODIFY_STUDY_TESTAMENT) {
        return state;
    }

    const testaments = action.payload;
    
    if (lodash.isNil(testaments) || lodash.isEmpty(testaments)) {
        return state;
    }

    return {
        ...state,
        doaTestaments: testaments,
    };
}

export function addOrModifyStudyTemplate(state, action){
    if(!action || action.type !== ADD_OR_MODIFY_STUDY_TEMPLATE){
        return state;
    }

    const newTemplate = action.payload;

    if(lodash.isNil(newTemplate) || lodash.isEmpty(newTemplate)){
        return state;
    }
    return{
        ...state,
        studyTemplates: newTemplate,
    };
}

export function getAllStudyTemplatesForInstitution(state, action){
    if(!action || action.type !== GET_ALL_STUDY_TEMPLATES_FOR_INSTITUTION){
        return state;
    }

    const templates = action.payload;
    
    if(lodash.isNil(templates) || lodash.isEmpty(templates)){
        return state;
    }

    return{
        ...state,
        studyTemplates: templates,
    };
}

export default composeReducers(
    addOrModifyStudyTestament,
    getAllStudyTemplatesForInstitution,
    addOrModifyStudyTemplate,
);